import { Injectable, isDevMode } from '@angular/core';
import { Http, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { FacebookService, InitParams } from 'ngx-facebook';
import { environment } from '../environments/environment'

import { LoaderService } from 'app/loader.service';

@Injectable()
export class ApiService {
  public Parse: any = require('parse');
  private facebookInitialized: boolean = false;

  constructor(
    private fb: FacebookService,
    private loaderService: LoaderService
  ) {
    // Initialise Parse with the app ID and JavaScript key
    this.Parse.initialize(environment.parse.appId, environment.parse.jsKey);

    // Define the Parse server URL
    this.Parse.serverURL = environment.parse.apiUrl;

    try {
      // Initialize Facebook app parameters
      this.Parse.FacebookUtils.init({
        appId: '439456899534282',
        cookie: true,
        xfbml: true,
        version: 'v2.9'
      });
      this.facebookInitialized = true;
    } catch (e) {
      isDevMode() && console.log(`Error initializing Facebook Utils: "${e.message}"`);
    }
  }

  isFacebookInitialized = (): boolean => this.facebookInitialized;
}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/api.service.ts